import { render } from "./PracticeChapters.vue?vue&type=template&id=7682eb86&scoped=true"
import script from "./PracticeChapters.vue?vue&type=script&lang=js"
export * from "./PracticeChapters.vue?vue&type=script&lang=js"

import "./PracticeChapters.vue?vue&type=style&index=0&id=7682eb86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7682eb86"]])

export default __exports__